// extracted by mini-css-extract-plugin
module.exports = {"body":"Form_body__4KAbD","form":"Form_form__2G91D"};